/* eslint-disable no-alert */
import { call, put } from 'redux-saga/effects'
import RegionActions from '../reducers/regionReducer'
import firebase from '../config/firebase'

export function* getRegions() {
  try {
    const ref = firebase.firestore().collection('regions')
    const snapshot = yield call([ref, ref.get])
    const regions = []

    if (snapshot.size > 0) {
      snapshot.forEach(doc => {
        regions.push({ ...doc.data(), id: doc.id })
      })
    }

    yield put(RegionActions.setRegions(regions))
  } catch (err) {
    alert(err)
    yield put(RegionActions.setRegions([]))
  }
}

export function* getDistricts({ payload: { region }}) {
  try {
    const collection = firebase
      .firestore()
      .collection('regions')
      .doc(region)
      .collection('districts')

    const snapshot = yield call([collection, collection.get])

    const data = {}

    snapshot.forEach(doc => {
      const snapshotData = doc.data()

      data[doc.id] = { ...snapshotData, id: doc.id }
    })

    yield put(RegionActions.setDistricts({ region, data }))
  } catch (error) {
    alert('Failed to get Districts')
    yield put(RegionActions.setDistricts({ region, data: {} }))
  }
}


// WEBPACK FOOTER //
// ./src/sagas/regionSaga.js